"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.register = register;
exports.startTour = startTour;
exports.setStep = setStep;
exports.endTour = endTour;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _enviro = _interopRequireDefault(require("enviro"));

var _OnboardingActionTypes = require("./OnboardingActionTypes");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

function register(_ref) {
  var name = _ref.name,
      gates = _ref.gates,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["name", "gates"]);

  if (!_enviro.default.debug(name) && !gates.every(function (gate) {
    return _IsUngatedStore.default.get(gate);
  })) {
    return;
  }

  (0, _Dispatch.dispatchQueue)(_OnboardingActionTypes.REGISTER_ONBOARDING, (0, _extends2.default)({
    name: name
  }, rest));
}

function startTour(name) {
  (0, _Dispatch.dispatchQueue)(_OnboardingActionTypes.START_ONBOARDING_TOUR, {
    name: name
  });
}

function setStep(name, onStep) {
  (0, _Dispatch.dispatchImmediate)(_OnboardingActionTypes.SET_ONBOARDING_TOUR_STEP, {
    name: name,
    onStep: onStep
  });
}

function endTour(name) {
  _enviro.default.setDebug(name, false);

  (0, _Dispatch.dispatchQueue)(_OnboardingActionTypes.END_ONBOARDING_TOUR, name);
}